import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppShell } from '../components/AppShell';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { GettingStarted } from '../components/GettingStarted';
import { deriveGettingStarted } from '../components/gettingStartedSteps';
import { useAuth } from '../auth/context';
import { useFocusMain } from '../a11y/useFocusMain';
import styles from './GetStarted.module.css';

/**
 * First-run landing for a signed-in user with no organization (#472). Shows the
 * Getting Started guide with "Create your organization" as the active step 1,
 * so onboarding starts in the guide rather than on a bare create-org form.
 */
export function GetStarted() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);
  useFocusMain();

  const guide = deriveGettingStarted({
    hasOrg: false,
    hasProject: false,
    anyVerified: false,
    anyScanned: false,
    anyJourneys: false,
    anyTestCases: false,
    targetProjectId: null,
  });

  const onSignOut = async () => {
    if (signingOut) return;
    setSigningOut(true);
    try {
      await logout();
    } finally {
      setSigningOut(false);
      navigate('/sign-in', { replace: true });
    }
  };

  return (
    <AppShell
      brand={
        <span className={styles.banner}>
          <span>TestCraft Journeys</span>
          <Button variant="ghost" busy={signingOut} onClick={onSignOut}>
            {signingOut ? 'Signing out…' : 'Sign out'}
          </Button>
        </span>
      }
    >
      <Card>
        <h1 className={styles.heading}>Welcome to TestCraft Journeys</h1>
        <p className={styles.subheading}>
          Follow these steps to start watching your store. Begin by creating your organization.
        </p>
      </Card>
      <GettingStarted
        steps={guide.steps}
        complete={guide.complete}
        currentStepNumber={guide.currentStepNumber}
      />
    </AppShell>
  );
}
